import React, { useCallback, useRef } from 'react';
import { toCanvas } from 'html-to-image';
import { ResourceModalContent } from './ResourceModalContent';
export var SelectedResourceContent = function (_a) {
    var modalResource = _a.modalResource, showShare = _a.showShare;
    var contentRef = useRef(null);
    var shareEvent = useCallback(function () {
        if (contentRef.current === null)
            return;
        var filename = modalResource.key || 'share-image';
        var shareImages = contentRef.current.querySelectorAll('[data-share-image]');
        if (shareImages.length) {
            shareImages.forEach(function (node, index) {
                var _a;
                var filenameSuffix = ((_a = node.dataset) === null || _a === void 0 ? void 0 : _a.shareImage) || index;
                toCanvas(node, { cacheBust: true, canvasWidth: 600, canvasHeight: 600 })
                    .then(function (canvas) {
                    // contentRef.current.appendChild( )
                    var link = document.createElement('a');
                    link.download = "".concat(filename, "-").concat(filenameSuffix, ".png");
                    link.href = canvas.toDataURL();
                    link.click();
                })
                    .catch(function (err) {
                    console.log(err);
                });
            });
        }
        else {
            toCanvas(contentRef.current, { cacheBust: true, canvasWidth: 600, canvasHeight: 600 })
                .then(function (canvas) {
                // contentRef.current.appendChild( )
                var link = document.createElement('a');
                // link.download = `${filename}.png`;
                link.href = canvas.toDataURL();
                link.click();
            })
                .catch(function (err) {
                console.log(err);
            });
        }
    }, [contentRef]);
    return (React.createElement("div", { tabIndex: 0 },
        React.createElement(ResourceModalContent, { vars: modalResource }),
        showShare && (React.createElement("div", { className: "EventModal__shareButtonContainer" },
            React.createElement("button", { className: 'Button Button--secondary EventModal__shareButton', onClick: shareEvent },
                React.createElement("span", { className: 'EventModal__shareButtonLabel' }, "Share"))))));
};
